export interface UpdateSystemUserPasswordRequest {
  password: string
  passwordNew: string
  passwordNewConfirm: string
}

export function UpdateSystemUserPasswordRequestToJSON(
  value: UpdateSystemUserPasswordRequest
): any {
  return {
    password: value.password !== '' ? value.password : undefined,
    password_new: value.passwordNew !== '' ? value.passwordNew : undefined,
    password_new_confirm:
      value.passwordNewConfirm !== '' ? value.passwordNewConfirm : undefined
  }
}
